// File: client/src/components/dashboard/KpiCard.js
import React from 'react';
import { Spinner } from 'react-bootstrap';

const KpiCard = ({ title, value, prefix = '', suffix = '', isLoading, icon: Icon, subtitle, description }) => {
    return (
        <div className="kpi-card">
            <div className="kpi-card__row">
                {Icon && <div className="kpi-card__icon"><Icon size={22} /></div>}
                {isLoading ? (
                    <Spinner animation="border" size="sm" />
                ) : (
                    <p className="kpi-card__value">
                        {prefix}{value}{suffix}
                    </p>
                )}
            </div>
            <h5 className="kpi-card__title">{title}</h5>
            {(subtitle || description) && (
                <span className="kpi-card__subtitle">{subtitle || description}</span>
            )}
        </div>
    );
};

export default KpiCard;
